import React from "react";
import PropTypes from "prop-types";
import { Divider } from "semantic-ui-react";
import { FormattedMessage } from "react-intl";
import RenameControl from "../../components/ui/RenameControl";
import OrganizerFileItem from "./view/OrganizerFileItem";

/**
 * OrganizerFileBrowser: props => React element
 *
 * (c) Stefan Wittwer 2018 | Alle Rechte vorbehalten.
 *
 * File browser on the right-hand side of the
 * Organizer window
 *
 * @param {*} props
 */
const OrganizerFileBrowser = props => (
  <div className={`or-files-view layout-${props.currentViewMode}`}>
    <div className="inner">
      <div className="or-header">
        {props.currentLocation ? (
          <RenameControl
            filename={props.currentLocation}
            saveDocumentTitle={props.setContextName}
          />
        ) : (
          <h2>
            <FormattedMessage id="organizer.states.noContextSelected" />
          </h2>
        )}
      </div>
      <Divider />
      {props.files.map(file => (
        <OrganizerFileItem
          filename={file.filename}
          type={file.documentType}
          key={file.id}
          onSelect={() => props.selectFile(file)}
          onDelete={() => props.deleteFile(file)}
        />
      ))}
    </div>
  </div>
);

OrganizerFileBrowser.propTypes = {
  /**
   * List of loaded files ordered by context identifier
   */
  files: PropTypes.arrayOf(
    PropTypes.shape({
      filename: PropTypes.string.isRequired
    })
  ).isRequired,
  /**
   * Function called when the user has selected a given file
   */
  selectFile: PropTypes.func.isRequired,
  /**
   * Function called when the user has deleted a given file
   */
  deleteFile: PropTypes.func.isRequired,
  /**
   * Display name of the current location, which will be displayed
   * in the view title
   */
  currentLocation: PropTypes.string,
  /**
   * Updates the display name of the current context
   */
  setContextName: PropTypes.func.isRequired,
  /**
   * Current view mode identifier
   */
  currentViewMode: PropTypes.string.isRequired
};

OrganizerFileBrowser.defaultProps = {
  currentLocation: null
};

export default OrganizerFileBrowser;



// WEBPACK FOOTER //
// ./src/modules/organizer/OrganizerFileBrowser.js